import path from 'node:path'
import { SNAPSHOT_ATTRIBUTES } from '@cli-constants/snapshots.js'
import { ensureLine } from './ensure-line.js'

export function ensureSnapshotGitattributes(cwd: string): void {
  ensureLine(path.join(cwd, '.gitattributes'), SNAPSHOT_ATTRIBUTES)
}
